import _ from 'lodash'
import { CancelTokenSource } from 'axios'
import axios from 'services/axios'
import { ENDPOINTS } from 'const/endpoints'
import { IPagination } from 'types/entities'
import { commonMessages } from 'utils/messages'
import { errorNotify, successNotify } from 'utils/toster'
import { ISessionClaimParams } from './ClaimsGeneralInvoice.interface'
import { onCreateEndpointsWithClientid } from 'utils/common'
/**
 * * getSessionClaimsListing section
 */
export function getSessionClaimsListing(
	clientId: string | undefined,
	params: Partial<ISessionClaimParams>,
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)

	const promise = axios.get<IPagination<Partial<any>>>(
		ENDPOINTS.SESSION_FEESCHEDULE_CLAIMS + '/' + clientId,
		{
			params: filteredParams,
		},
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}
/**
 * * Create Claims Invoice section
 */
export function createClaimsInvoice(data: Partial<any>, source?: CancelTokenSource) {
	const promise = axios.post<any>(onCreateEndpointsWithClientid(ENDPOINTS.CLAIMS_INVOICE), data)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}

/**
 * * Download PDF section
 */
export function downloadPdf(params?: any, source?: CancelTokenSource) {
	const checkPath = `${onCreateEndpointsWithClientid(ENDPOINTS.CLAIMS_INVOICE)}`
	const config: any = {
		responseType: 'blob',
	}

	const promise = axios
		.post(checkPath, params, config)
		.then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]))
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'Invoice.pdf')

			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
			successNotify('PDF downloaded successfully')
		})
		.catch((error) => {
			errorNotify('Error downloading PDF')
		})

	return promise
}
